import React from "react";
import styles from "../../styles/HomePage.module.css"; // ✅ Required import


const cars = [
  {
    title: "Hyundai Creta",
    img: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1524&q=80",
    year: 2020,
    km: "25,000 km",
    fuel: "Petrol",
    price: "₹9.5 Lakh",
  },
  {
    title: "Maruti Swift",
    img: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?auto=format&fit=crop&w=1524&q=80",
    year: 2019,
    km: "30,000 km",
    fuel: "Diesel",
    price: "₹6.2 Lakh",
  },
  {
    title: "Honda City",
    img: "https://images.unsplash.com/photo-1541899481282-d53bffe3c35d?auto=format&fit=crop&w=1470&q=80",
    year: 2021,
    km: "15,000 km",
    fuel: "Petrol",
    price: "₹11.8 Lakh",
  },
];

const FeaturedCars = () => {
  return (
    <section className={styles.featuredCars}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Featured Cars</h2>
        <div className={styles.carGrid}>
          {cars.map((car, idx) => (
            <div key={idx} className={styles.carCard}>
              <div className={styles.carImg}>
                <img src={car.img} alt={car.title} />
                <span className={styles.carBadge}>Certified</span>
              </div>
              <div className={styles.carInfo}>
                <h3>{car.title}</h3>
                <div className={styles.carSpecs}>
                  <span>
                    <i className="fas fa-calendar-alt"></i> {car.year}
                  </span>
                  <span>
                    <i className="fas fa-tachometer-alt"></i> {car.km}
                  </span>
                  <span>
                    <i className="fas fa-gas-pump"></i> {car.fuel}
                  </span>
                </div>
                <div className={styles.carPrice}>
                  <h4>{car.price}</h4>
                  <a href="#" className={styles.btn}>
                    View Details
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <a href="#" className={styles.btn}>
            View All Cars
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCars;
